import React, { useEffect } from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { Observer } from 'mobx-react';
import { toJS, autorun } from 'mobx';
import { useRootStore } from '../../stores/BridgeProvider';

const UseJoyride = ({
  passedSteps,
  customProps,
  tooltipComponent,
  passedID,
}) => {
  return (
    <Observer
      render={() => {
        const { joyrideStore, authStore, orgStore } = useRootStore();
        const { run, stepIndex, steps } = joyrideStore;
        const tourState = { run, stepIndex, steps };

        const joyrideID = passedID || window.location.pathname.split('/')[1];

        const callback = async data => {
          const { action, index, type, status } = data;

          if (
            // If close button clicked, then close the tour
            action === ACTIONS.CLOSE ||
            // If skipped or end tour, then close the tour
            (status === STATUS.SKIPPED && tourState.run) ||
            status === STATUS.FINISHED
          ) {
            try {
              joyrideStore.stopRun();
              await authStore.request.post(
                `${process.env.REACT_APP_API}/api/joyride`,
                {
                  Joyride: joyrideID,
                },
              );
              orgStore.retrieveJoyrides();
            } catch (e) {
              console.error(e);
            }
          } else if (
            type === EVENTS.STEP_AFTER ||
            type === EVENTS.TARGET_NOT_FOUND
          ) {
            // Check whether next or back button click and update the step.
            if (action === ACTIONS.PREV) {
              joyrideStore.setStepIndex(index + -1);
            } else if (action === ACTIONS.NEXT && index !== steps.length - 1) {
              joyrideStore.setStepIndex(index + 1);
            } else {
              try {
                joyrideStore.stopRun();
                joyrideStore.setStepIndex(0);
                await authStore.request.post(
                  `${process.env.REACT_APP_API}/api/joyride`,
                  {
                    Joyride: joyrideID,
                  },
                );
                orgStore.retrieveJoyrides();
              } catch (e) {
                console.error(e);
              }
            }
          }
        };

        useEffect(
          () =>
            autorun(() => {
              joyrideStore.setSteps(passedSteps);
              joyrideStore.setID(joyrideID);
              const joyrideArray = orgStore.joyrides;
              const { isNewJoyride } = orgStore;
              if (!joyrideArray) {
                orgStore.retrieveJoyrides();
              } else if (isNewJoyride(joyrideID)) {
                joyrideStore.start();
              }
            }),
          [],
        );
        return (
          passedSteps.length === steps.length && (
            <Joyride
              showSkipButton
              {...customProps}
              {...tourState}
              callback={callback}
              locale={{ last: 'Close' }}
              tooltipComponent={tooltipComponent}
            />
          )
        );
      }}
    />
  );
};

export default UseJoyride;
